import { doPost, doPostWithoutSessionToken } from './apiUtils';
import {
  getStringFromLS,
  getUserAgentId,
} from '../shared/helper-utils/localStorage';
import { APP_MAIN_URL, APP_USER_AUTH } from '../saas/AppStorageStaticNames';

export const getProfileApi = async (req) => {
  const response = await doPost(req);
  return response;
};

export const updateProfileApi = async (profileObj) => {
  const request = {
    opid: 'UPDATEAGENTPROFILE',
    jsonrequest: JSON.stringify({
      userupdaterequest: profileObj,
    }),
  };
  const response = await doPost(request);
  return response;
};

export const updateGSTApi = async (gstDetails) => {
  const request = {
    opid: 'UPDATEAGENTPROFILE',
    actioncode: 'UPDATEGST',
    jsonrequest: JSON.stringify({
      gstupdaterequest: gstDetails,
    }),
  };
  const response = await doPost(request);
  return response;
};

export const getAllPersonalTravellersApi = async (agentId) => {
  const request = {
    opid: 'FS000',
    actioncode: 'GETALLPERSONALTRAVELLERS',
    agentid: agentId,
  };
  const response = await doPost(request);
  return response;
};

export const addPersonalTravellerApi = async (req) => {
  const agentId = getUserAgentId();
  const request = {
    opid: 'FS000',
    actioncode: 'ADDPERSONALTRAVELLER',
    agentid: agentId,
    jsondata: JSON.stringify(req),
  };
  const response = await doPost(request);
  return response;
};

export const deletePersonalTravellerApi = async (agentId, travellerId) => {
  const request = {
    opid: 'FS000',
    actioncode: 'DELETEPERSONALTRAVELLER',
    agentid: agentId,
    travellerid: travellerId,
  };
  const response = await doPost(request);
  return response;
};

export const getUserDetails = async (agentId) => {
  const request = {
    opid: 'GETUSERDETAILSV4',
    agentid: agentId,
  };
  const response = await doPost(request);
  return response;
};

export const getAgentBalanceApi = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP036',
    actioncode: 'GETBALANCE',
    agentid,
  };
  const response = await doPost(req);
  return response;
};

export const getLedgerApi = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP036',
    actioncode: 'GETLEDGER',
    agentid,
    fromdate,
    todate,
    resultformat: 'json',
  };
  const response = await doPost(req);
  return response;
};

export const changePasswordApi = async (newpassword, oldpassword) => {
  const agentid = getUserAgentId();
  const req = {
    agentid,
    opid: 'MU022',
    newpassword,
    oldpassword,
    responseformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getAllStaff = async () => {
  const agentid = getUserAgentId();
  const req = {
    agentid,
    opid: 'MU001',
    actioncode: 'GETALLAGENTSTAFF',
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const addStaff = async (request) => {
  const agentid = getUserAgentId();
  const encodedRequest = btoa(
    unescape(
      encodeURIComponent(
        JSON.stringify({
          useraddrequest: request,
        }),
      ),
    ),
  );
  const req = {
    agentid,
    opid: 'MU001',
    actioncode: 'ADDSTAFF',
    jsonrequest: encodedRequest,
    isenc: 'true',
  };
  const response = await doPost(req);
  return response;
};

export const updateStaff = async (request) => {
  const agentid = getUserAgentId();
  const req = {
    agentid,
    opid: 'MU001',
    actioncode: 'UPDATESTAFFPROFILE',
    jsonrequest: JSON.stringify({
      userupdaterequest: request,
    }),
  };
  const response = await doPost(req);
  return response;
};

export const getStaffById = async (staffId) => {
  const req = {
    opid: 'MU001',
    actioncode: 'GETSTAFFDETAIL',
    agentid: staffId,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const logoutApi = async () => {
  const req = {
    opid: 'LOGOUTV2',
  };

  const response = await doPost(req);
  return response;
};

export default {
  getProfileApi,
};

export const getGstCommissionApi = async (month, year) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'GSTINPUT',
    actioncode: 'GETCOMMISSION',
    gstmonth: month,
    gstyear: year,
    agentid,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getRecentTransactionsApi = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP006',
    actioncode: 'RECENTRECEIPTTXN',
    agentid,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getCustomerMarkupForAgentApi = async (agentid) => {
  const req = {
    opid: 'DC001',
    actioncode: 'GETCUSTOMERMARKUPFORAGENT',
    agentid,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getClientCommissionsApi = async (serviceType) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DC004',
    actioncode: 'COMMNEWALL',
    agentid,
    groupplanid: 3,
    servicetype: serviceType,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getAgentCouponApi = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'AGENTCOUPON',
    actioncode: 'GETALLCOUPONMASTERSFORAGENT',
    agentid,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getCreditNotes = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP016',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getDebitNotes = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP017',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getTopUpReceipts = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP001',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getCreditNotesReceipt = async (txId) => {
  try {
    const agentid = getUserAgentId();
    const req = {
      opid: 'RQ000',
      actioncode: 'RQ005',
      agentid,
      txid: txId,
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFundTransfers = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP003',
    actioncode: 'USER',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};
export const getFundReversals = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP004',
    actioncode: 'USER',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getTopupReceipt = async (txId) => {
  try {
    const agentid = getUserAgentId();
    const req = {
      opid: 'RQ000',
      actioncode: 'RQ006',
      agentid,
      txid: txId,
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getTransactionDetails = async (txId) => {
  try {
    const req = {
      opid: 'ST000',
      withssr: true,
      txid: txId,
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getMobileDataRechargeHistory = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP041',
    actioncode: 'USER',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getDmtAgentsDetails = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTMANAGER',
    actioncode: 'GETDMTAGENTDETAIL',
    agentid,
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getAllDmtCustomersByAgentid = async () => {
  const agentId = getUserAgentId();
  const req = {
    opid: 'DMTMANAGER',
    actioncode: 'GETALLDMTCUSTOMERSBYAGENTID',
    agentid: agentId,
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getDmtBookings = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTMANAGER',
    actioncode: 'GETDMTTRANSACTIONSBYAGENTID',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getGstInputInvoiceHistory = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'GSTINPUT',
    actioncode: 'GETALLGSTINPUTINVOICE',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getAmcTransactionsHistory = async (fromdate, todate) => {
  try {
    const agentid = getUserAgentId();
    const req = {
      opid: 'USERSUBSCRIPTIONSETTING',
      actioncode: 'USERSUBSCRIPTIONSETTINGFORAGENT',
      agentid,
      fromdate,
      todate,
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getSsrHistory = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'RP023',
    actioncode: 'GETSSRHISTORYFORAGENT',
    agentid,
    fromdate,
    todate,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getSupplierOperators = async () => {
  const req = {
    opid: 'TX039',
    actioncode: 'GETSUPPLIEROPERATORS',
    rechargetype: 'mobilerecharge',
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getMobileRechargeFare = async (operatorId, name, amount) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX039',
    agentid,
    operatorid: operatorId,
    operatorname: name,
    rechargeamount: amount,
    rechargetype: 'mobilerecharge',
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const makePayment = async (paymentObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX019',
    actioncode: 'RCPT',
    resultformat: 'JSON',
    jsonrequest: JSON.stringify({
      receiptrequest: {
        ...paymentObj,
        agentid,
      },
    }),
  };
  const response = await doPost(req);
  return response;
};

export const addMarkup = async (markUpObj) => {
  const agentId = getUserAgentId();
  const req = {
    opid: 'DC001',
    actioncode: 'ADDCUSTOMERMARKUPNEW',
    resultformat: 'JSON',
    agentid: agentId,
    ...markUpObj,
  };
  const response = await doPost(req);
  return response;
};
export const updateMarkup = async (markUpObj) => {
  const agentId = getUserAgentId();
  const req = {
    opid: 'DC001',
    actioncode: 'UPDATECUSTOMERMARKUPNEW',
    resultformat: 'JSON',
    agentid: agentId,
    ...markUpObj,
  };
  const response = await doPost(req);
  return response;
};

export const deleteMarkUp = async (markUpId) => {
  const agentId = getUserAgentId();
  const req = {
    opid: 'DC001',
    actioncode: 'DELETECUSTOMERMARKUPNEW',
    resultformat: 'JSON',
    agentid: agentId,
    markupid: markUpId,
  };
  const response = await doPost(req);
  return response;
};

export const generateTpin = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'MU007',
    actioncode: 'GENERATETPIN',
    agentid,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getTpin = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'MU007',
    actioncode: 'GETTPIN',
    agentid,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const updateTpin = async (tpinno) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'MU007',
    actioncode: 'UPDATETPIN',
    tpin: tpinno,
    agentid,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const updatePasswordForStaff = async (newPassword, selectedAgentId) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'MU022',
    actioncode: 'CHANGEPASSWORDV2',
    password: newPassword,
    sessionusernew: agentid,
    agentid: selectedAgentId,
    isadminpanel: 'true',
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const raiseSupportRequest = async (reason, txId, txDate, remarks) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX045',
    domint: 'dom',
    reqtype: 'GENERICSUPPORT',
    agentid,
    req_subtype: reason,
    txid: txId,
    txdate: txDate,
    reqdetails: remarks,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const supportRequest = async (name, email, content) => {
  const req = {
    opid: 'EM001',
    subject: 'Your Flight Booking Details',
    fromname: name,
    fromemail: email,
    htmlcontent: content,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};
export const creditRequest = async (name, emailSubject, email, content) => {
  const req = {
    opid: 'EM001',
    subject: emailSubject,
    fromname: name,
    fromemail: email,
    htmlcontent: content,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const raiseCreditRequest = async (reqObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX045',
    reqtype: 'CREDITREQUEST',
    req_subtype: 'CREDITREQUEST',
    resultformat: 'JSON',
    domint: 'credit',
    agentid,
    ...reqObj,
  };
  const response = await doPost(req);
  return response;
};

export const groupBookingRequest = async (domInt, content) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX045',
    agentid,
    resultformat: 'JSON',
    reqtype: 'GROUPREQUEST',
    req_subtype: 'Group Booking',
    txid: '',
    txdate: '',
    domint: domInt,
    reqdetails: content,
  };
  const response = await doPost(req);
  return response;
};

export const flightDayWiseAvail = async (record) => {
  const req = {
    opid: 'MQ000',
    actioncode: 'GETFLIGHTDAYWISEAVAIL',
    couponid: record,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getCouponLogs = async (record) => {
  const req = {
    opid: 'MQ000',
    actioncode: 'GETCOUPONLOGS',
    recordid: record,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const getFlightDaywiseAvailRecord = async (record) => {
  const req = {
    opid: 'MQ000',
    actioncode: 'GETFLIGHTDAYWISEAVAILRECORD',
    recordid: record,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const deleteAgentSeriesFare = async (record) => {
  const req = {
    opid: 'MQ000',
    actioncode: 'DELETECOUPONMASTER',
    couponid: record,
    resultformat: 'JSON',
  };
  const response = await doPost(req);
  return response;
};

export const acceptReceiptRequest = async (reqObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX019',
    actioncode: 'RCPT',
    resultformat: 'JSON',
    jsonrequest: JSON.stringify({
      receiptrequest: {
        ...reqObj,
        agentid,
      },
    }),
  };
  const response = await doPost(req);
  return response;
};

export const rechargeMobile = async (reqObj, amount) => {
  const req = {
    opid: 'TX038',
    actioncode: 'RECHARGEV2',
    resultformat: 'JSON',
    totalinvoice: amount,
    ...reqObj,
    promocode: '',
  };
  const response = await doPost(req);
  return response;
};

export const getMobileDthReceipt = async (txid) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX042',
    resultformat: 'JSON',
    agentid,
    txid,
  };
  const response = await doPost(req);
  return response;
};

export const getDthFare = async (operatorId, name, amount) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'TX043',
    resultformat: 'JSON',
    actioncode: 'GETFARE',
    agentid,
    operatorid: operatorId,
    operatorname: name,
    rechargeamount: amount,
    rechargetype: 'dthrecharge',
  };
  const response = await doPost(req);
  return response;
};

export const rechargeDth = async (rechargeObj, amount) => {
  const req = {
    opid: 'TX043',
    actioncode: 'RECHARGEV2',
    resultformat: 'JSON',
    totalinvoice: amount,
    ...rechargeObj,
  };
  const response = await doPost(req);
  return response;
};

export const addAgentCouponDetails = async (couponObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'AGENTCOUPON',
    actioncode: 'ADDAGENTCOUPON',
    resultformat: 'JSON',
    agentid,
    ...couponObj,
  };
  const res = await doPost(req);
  return res;
};

export const getAllDmtAccountsByDmtCustomerid = async (custId) => {
  const req = {
    opid: 'DMTMANAGER',
    actioncode: 'GETALLDMTACCOUNTSBYDMTCUSTOMERID',
    dmtcustomerid: custId,
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
  };
  const res = await doPost(req);
  return res;
};

export const dmtFundTransfer = async (fundObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'FUNDTRANSFER',
    agentid,
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
    ...fundObj,
  };
  const res = await doPost(req);
  return res;
};

export const getDmtFare = async (amount) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'GETDMTFARE',
    apiname: 'instantpaydmt',
    transferamount: amount,
    agentid,
    resultformat: 'JSON',
  };
  const res = await doPost(req);
  return res;
};

export const getDmtTransactionsbyTxid = async (txid) => {
  const req = {
    opid: 'DMTMANAGER',
    actioncode: 'GETDMTTRANSACTIONSBYTXID',
    txid,
    resultformat: 'JSON',
  };
  const res = await doPost(req);
  return res;
};

export const addDmtCustomer = async (reqObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'ADDCUSTOMER',
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
    agentid,
    ...reqObj,
  };
  const res = await doPost(req);
  return res;
};
export const customerOtpVerification = async (refOtp, otpEntered) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'CUSTOMEROTPVALIDATION',
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
    requestid: refOtp,
    otp: otpEntered,
    agentid,
  };
  const res = await doPost(req);
  return res;
};

export const getBankDetails = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTMANAGER',
    actioncode: 'GETDMTBANKDETAIL',
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
    agentid,
  };
  const res = await doPost(req);
  return res;
};

export const activateBeneficiary = async (recordid) => {
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'ACTIVATEBENEFICIARY',
    dmtaccountid: recordid,
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
  };
  const res = await doPost(req);
  return res;
};

export const deactivateBeneficiary = async (recordid) => {
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'REMOVEBENEFICIARY',
    dmtaccountid: recordid,
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
  };
  const res = await doPost(req);
  return res;
};

export const resendBeneficiaryOtpValidation = async (recordId) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'RESENDBENEFICIARYOTPVALIDATION',
    recordid: recordId,
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
    agentid,
  };
  const res = await doPost(req);
  return res;
};

export const verifyAndAddBeneficiary = async (reqObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'VERIFYANDADDBENEFICIARY',
    resultformat: 'JSON',
    apiname: 'instantpaydmt',
    agentid,
    ...reqObj,
  };
  const res = await doPost(req);
  return res;
};
export const addBeneficiaryWithoutVerify = async (reqObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'ADDBENEFICIARY',
    resultformat: 'JSON',
    apiname: 'instantpaydmt',
    agentid,
    ...reqObj,
  };
  const res = await doPost(req);
  return res;
};

export const beneficiaryOtpValidation = async (refOtp, otpEntered) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'DMTBOOKING',
    actioncode: 'BENEFICIARYOTPVALIDATION',
    apiname: 'instantpaydmt',
    resultformat: 'JSON',
    requestid: refOtp,
    otp: otpEntered,
    agentid,
  };
  const res = await doPost(req);
  return res;
};

export const getBankCodesForAeps = async () => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'AEPS',
    actioncode: 'BANKCODE',
    apiname: 'instantpayaeps',
    resultformat: 'JSON',
    agentid,
  };
  const res = await doPost(req);
  return res;
};

export async function discoverRdServices() {
  const primaryUrl =
    window.location.protocol === 'https:'
      ? 'https://127.0.0.1:11100'
      : 'http://127.0.0.1:11100';

  const response = await fetch(primaryUrl, {
    method: 'RDSERVICE',
    mode: 'cors',
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
    },
  });

  const responseText = response;
  return responseText;
}

export async function captureAuthentication() {
  const primaryUrl =
    window.location.protocol === 'https:'
      ? 'https://127.0.0.1:11100/rd/capture'
      : 'http://127.0.0.1:11100/rd/capture';

  const xmlData =
    '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0"   pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';

  const response = await fetch(primaryUrl, {
    method: 'CAPTURE',
    mode: 'cors',
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
    },
    body: xmlData,
  });
  const responseText = response;
  return responseText;
}

export const balanceEnquiryAuthentication = async (reqObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'AEPS',
    actioncode: 'BALANCEENQUIRY',
    apiname: 'instantpayaeps',
    resultformat: 'JSON',
    agentid,
    ...reqObj,
  };
  const res = await doPost(req);
  return res;
};
export const ministatementAuthentication = async (reqObj) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'AEPS',
    actioncode: 'MINISTATEMENT',
    apiname: 'instantpayaeps',
    resultformat: 'JSON',
    agentid,
    ...reqObj,
  };
  const res = await doPost(req);
  return res;
};
export const cashwithdrawlAuthentication = async (reqObj, amount) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'AEPS',
    actioncode: 'CASHWITHDRAWAL',
    apiname: 'instantpayaeps',
    resultformat: 'JSON',
    agentid,
    amount,
    ...reqObj,
  };
  const res = await doPost(req);
  return res;
};

export async function discoverRdServicesLog() {
  const primaryUrl =
    window.location.protocol === 'https:'
      ? 'https://127.0.0.1:11100'
      : 'http://127.0.0.1:11100';

  const response = await fetch(primaryUrl, {
    method: 'RDSERVICE',
    mode: 'cors',
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
    },
  });

  const responseText = response;
  return responseText;
}

export async function captureAuthenticationLog() {
  const primaryUrl =
    window.location.protocol === 'https:'
      ? 'https://127.0.0.1:11100/rd/capture'
      : 'http://127.0.0.1:11100/rd/capture';

  const xmlData =
    '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0"   pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';

  const response = await fetch(primaryUrl, {
    method: 'CAPTURE',
    mode: 'cors',
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
    },
    body: xmlData,
  });
  const responseText = response;
  return responseText;
}

export const loginFingerAuthentication = async (aadhar, data) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'AEPS',
    actioncode: 'AEPSDEVICELOGIN',
    apiname: 'instantpayaeps',
    resultformat: 'JSON',
    aadhaarnumber: aadhar,
    piddata: data,
    agentid,
  };
  const res = await doPost(req);
  return res;
};

export const performGstInputInvoice = async (reqObj) => {
  const req = {
    opid: 'GSTINPUT',
    actioncode: 'PERFROMGSTINPUTINVOICE',
    resultformat: 'JSON',
    ...reqObj,
  };
  const res = await doPost(req);
  return res;
};

export const updateGstInputInvoiceForAgent = async (
  billnumber,
  billdate,
  txId,
) => {
  const req = {
    opid: 'GSTINPUT',
    actioncode: 'UPDATEGSTINPUTINVOICEFORAGENT',
    resultformat: 'JSON',
    gst_billnumber: billnumber,
    gst_billdate: billdate,
    txid: txId,
  };
  const res = await doPost(req);
  return res;
};

export const uploadGstInputDocumentByAgent = async (Txid, url) => {
  const req = {
    opid: 'GSTINPUT',
    actioncode: 'UPLOADGSTINPUTDOCUMENTBYAGENT',
    txid: Txid,
    uploaddocument_url: url,
    resultformat: 'JSON',
  };
  const res = await doPost(req);
  return res;
};

export const uploadLogoFile = async (obj) => {
  const agentId = getUserAgentId();
  const sessiontoken = getStringFromLS(APP_USER_AUTH);
  const API_PATH = getStringFromLS(APP_MAIN_URL);
  const url = `${API_PATH}s3fileupload.jsp?agentid=${agentId}&sessiontoken=${sessiontoken}`;
  try {
    // eslint-disable-next-line no-undef
    const res = await fetch(url, {
      method: 'post',
      body: obj,
    });
    return res;
  } catch (error) {
    return undefined;
  }
};

export const updateLogoInProfileApi = async (imageurl) => {
  try {
    const req = {
      opid: 'MU031',
      actioncode: 'UPDATEOTHERINFO',
      uploadtype: 'logo',
      agentid: getUserAgentId(),
      imageurl,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const sendVisaRequest = async (
  reqObj,
  fromemail,
  fromname,
  toemail,
  subject,
  // subject,
  // fromname,
  // fromemail,
  // toemail,
  // htmlcontent,
) => {
  try {
    const req = {
      // opid: 'EM001',
      opid: 'GENERIC',
      actioncode: 'SENDVISAREQUEST',
      resultformat: 'JSON',
      req_type: 'VisaRequest',
      subject,
      fromname,
      fromemail,
      toemail,
      // htmlcontent,
      jsonrequest: JSON.stringify({
        visa_request: reqObj,
      }),
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const getInsuarnceIds = async (request) => {
  try {
    const req = {
      opid: 'TRAWELLTAGAPI',
      resultformat: 'JSON',
      actioncode: 'GETALLCATEGORIES',
      ...request,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const getInsuranceInfo = async (request) => {
  try {
    const req = {
      opid: 'TRAWELLTAGAPI',
      resultformat: 'JSON',
      ...request,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const uploadDocForMakePayment = async (obj) => {
  const API_PATH = getStringFromLS(APP_MAIN_URL);
  const url = `${API_PATH}s3fileupload.jsp?resultformat=JSON`;
  try {
    // eslint-disable-next-line no-undef
    const res = await fetch(url, {
      method: 'post',
      body: obj,
    });
    if (res) {
      return res;
    }
    const response = await res.json();
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getMessageFromAdmin = async () => {
  try {
    const agentid = getUserAgentId();
    const req = {
      opid: 'MM001',
      resultformat: 'JSON',
      agentid,
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getAllIdentities = async () => {
  try {
    const req = {
      opid: 'PROFILE003',
      actioncode: 'GETALLIDENTITIES',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const emulateUserApi = async (emulateagentid) => {
  try {
    const req = {
      opid: 'GETEMULATEUSER',
      emulateagentid,
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const loginWithSSOApi = async (ssotoken) => {
  try {
    const request = {
      opid: 'IWEENSSO',
      ssotoken,
      sessiontoken: ssotoken,
    };
    const loginResponse = await doPostWithoutSessionToken(request);
    return loginResponse;
  } catch (error) {
    return undefined;
  }
};
export const getIpAddressApi = async () => {
  try {
    const request = {
      opid: 'GENERIC',
      actioncode: 'GETUSERIPADDRESS',
    };
    const response = await doPostWithoutSessionToken(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const sendThankyouForRegistration = async (
  subject,
  toemail,
  htmlcontent,
  agentname,
) => {
  try {
    const req = {
      opid: 'EM001',
      resultformat: 'JSON',
      subject,
      fromname: '',
      fromemail: '',
      toemail,
      htmlcontent,
      agentname,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const getBannerImagesForLogin = async () => {
  try {
    const req = {
      opid: 'GENERIC',
      actioncode: 'SHOWALLIMGFORLOGIN',
      resultformat: 'JSON',
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};
export const getFareInsuarance = async (request) => {
  try {
    const req = {
      opid: 'TRAWELLTAGAPI',
      resultformat: 'JSON',
      ...request,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};
export const getInsuranceBookings = async (fromdate, todate) => {
  const agentid = getUserAgentId();
  try {
    const req = {
      opid: 'OFFLINE',
      actioncode: 'GETINSURANCEFORAGENT',
      agentid,
      fromdate,
      todate,
      branchname: 'all',
      staffid: 'all',
      customerid: 'all',
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getInsuranceBookingDetails = async (txid) => {
  try {
    const req = {
      opid: 'OFFLINE',
      actioncode: 'GETINSURANCERECORDDETAILS',
      invoice_number: txid,
      agentid: getUserAgentId(),
      resultformat: 'JSON',
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};
export const getTransactionByParams = async (txId, txType, reqParams) => {
  const agentid = getUserAgentId();
  try {
    const req = {
      opid: 'ST000',
      resultformat: 'JSON',
      agentid,
      txid: txId,
      txtype: txType,
      ...reqParams,
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const sendVisaRequestApi = async (
  reqObj,
  fromemail,
  fromname,
  toemail,
  subject,
) => {
  try {
    const req = {
      opid: 'GENERIC',
      actioncode: 'SENDVISAREQUEST',
      resultformat: 'JSON',
      req_type: 'VisaRequest',
      fromemail,
      toemail,
      subject,
      fromname,
      jsonrequest: JSON.stringify({
        visa_request: reqObj,
      }),
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const deleteAccountApi = async (agentid) => {
  try {
    const req = {
      opid: 'PROFILE003',
      actioncode: 'DELETEACCOUNT',
      profileid: agentid,
      resultformat: 'JSON',
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};
export const addAgentSeriesFareCouponApi = async (
  agentCouponDetails,
  secArr,
) => {
  try {
    const req = {
      opid: 'AGENTCOUPON',
      actioncode: 'ADDAGENTCOUPONV2',
      resultformat: 'JSON',
      agentid: getUserAgentId(),
      jsonrequest: JSON.stringify({
        coupon_master: {
          ...agentCouponDetails,
          coupon_sectors: [...secArr],
        },
      }),
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const sendEnquiryEmailApi = async (formData) => {
  try {
    const req = {
      opid: 'MU025',
      actioncode: 'SENDCONTACTUSQUIRY',
      ...formData,
    };
    const res = await doPostWithoutSessionToken(req);
    return res;
  } catch (error) {
    return undefined;
  }
};
export const getStaticPageContent = async (pagename) => {
  try {
    const req = {
      opid: 'GENERIC',
      actioncode: 'STATICCONTENT',
      resultformat: 'JSON',
      pagename,
    };
    const res = await doPostWithoutSessionToken(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const getSeriesFarePnrReport = async (reqObj, reportType) => {
  try {
    const req = {
      opid: 'AGENTCOUPON',
      actioncode: 'SERIESFAREPNRREPORTV2AGENT',
      responseformat: 'JSON',
      resultformat: 'JSON',
      reporttype: reportType,
      agentid: getUserAgentId(),
      ...reqObj,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const editDaywiseAvailApi = async (reqObj) => {
  try {
    const req = {
      opid: 'MQ000',
      actioncode: 'UPDATEFLIGHTDAYWISEAVAIL',
      resultformat: 'JSON',
      ...reqObj,
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};
